module.exports = __webpack_public_path__ + "a83cf250da122f363430d2eb3b46056b.svg";